export const baseEnvironment = {
  appName: 'Marking Guide',
  version: '0.0.1',
};
